(() => {
  'use strict';
  const html = document.documentElement;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const allowed = () => html.dataset.motion !== 'off' && html.dataset.readingCalm !== 'on' && (!reduced.matches || html.dataset.motionChoice === 'on');
  const active = new Set();
  function animate(node, frames, duration) {
    if (!node?.animate || !allowed()) return;
    const animation = node.animate(frames, { duration, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'none' });
    active.add(animation);
    animation.finished.then(() => active.delete(animation), () => active.delete(animation));
  }
  function openTarget() {
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    if (!id) return;
    const target = document.getElementById(id);
    if (!target) return;
    if (target.closest('[data-journal22]')?.dataset.journal22Enhanced) return;
    let parent = target;
    while (parent && parent !== document.body) {
      if (parent instanceof HTMLDetailsElement) parent.open = true;
      parent = parent.parentElement;
    }
    if (target.closest('.commerce21-story') || target.matches('.standard21 details')) requestAnimationFrame(() => target.scrollIntoView({ block: 'start', behavior: 'instant' }));
  }
  function entry(scope = document) {
    const selector = '.world21[data-v21-world],.standard21[data-v21-world]';
    const roots = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) roots.unshift(scope);
    for (const root of roots) {
      if (root.dataset.fast21Ready) continue;
      root.dataset.fast21Ready = 'true';
      const identity = root.dataset.v21World;
      const copy = root.querySelector('.world21__copy,.standard21__header');
      const shift = identity === 'achievements' ? 10 : 14;
      animate(copy, [{ opacity: .78, transform: `translateY(${shift}px)` }, { opacity: 1, transform: 'translateY(0)' }], identity === 'achievements' ? 260 : 340);
      root.querySelectorAll('.world21__card').forEach((card, index) => animate(card, [{ opacity: .85, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }], 220 + Math.min(index, 3) * 30));
    }
  }
  function directory(scope = document) {
    scope.querySelectorAll('[data-directory21]').forEach(root => {
      if (root.dataset.ready21) return;
      root.dataset.ready21 = 'true';
      const filters = [...root.querySelectorAll('[data-directory21-filter]')];
      const cards = [...root.querySelectorAll('[data-directory21-card]')];
      const empty = root.querySelector('[data-directory21-empty]');
      const valid = new Set(['all', 'hotels', 'dining', 'nightlife', 'shops']);
      const update = (value, updateUrl) => {
        let count = 0;
        for (const card of cards) {
          card.hidden = value !== 'all' && card.dataset.category !== value;
          if (!card.hidden) count++;
        }
        if (empty) empty.hidden = count > 0;
        if (updateUrl) {
          const url = new URL(location.href);
          value === 'all' ? url.searchParams.delete('category') : url.searchParams.set('category', value);
          history.replaceState(history.state, '', url);
        }
      };
      const chosen = new URL(location.href).searchParams.get('category');
      const initial = valid.has(chosen) ? chosen : 'all';
      filters.forEach(input => { input.checked = input.value === initial; input.addEventListener('change', () => update(input.value, true)); });
      update(initial, false);
    });
  }
  function preferences() { if (!allowed()) for (const animation of active) animation.cancel(); }
  new MutationObserver(preferences).observe(html, { attributes: true, attributeFilter: ['data-motion', 'data-motion-choice', 'data-reading-calm'] });
  reduced.addEventListener('change', preferences);
  addEventListener('pagehide', () => { for (const animation of active) animation.cancel(); });
  addEventListener('hashchange', openTarget);
  document.addEventListener('shopify:section:load', event => { entry(event.target); directory(event.target); });
  entry();
  directory();
  openTarget();
})();
